
import React from 'react';

const PrivacyPolicy = () => (
  <div className="max-w-3xl mx-auto py-10 px-4 text-gray-300">
    <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1>
    <p className="mb-4">
      We value your privacy. All personal data collected through our platform is handled with strict confidentiality.
      We do not share or sell your information to third parties. You may request data deletion at any time.
    </p>
  </div>
);

export default PrivacyPolicy;
